export const algo = [
	{
		"id": 1,
		"algoName": "Visualize Algorithm",
		"name": "Sorting",
		"desc": "Sorting refers to arranging data in a particular format. Sorting algorithm specifies the way to arrange data in a particular order. Most common orders are in numerical or lexicographical order."

    },
	{
		"id": 2,
		"algoName": "Visualize MergeSort",
		"name": "MergeSort",
		"desc": "In Merge Sort, the given unsorted array with n elements, is divided into n subarrays, each having one element, because a single element is always sorted in itself. Then, it repeatedly merges these subarrays, to produce new sorted subarrays, and in the end, one complete sorted array is produced.‏‏\n‎Time-Complexity: O(n*logn)\nSpace-Complexity: O(n)"
	},
	{
		"id": 3,
		"algoName": "Visualize BubbleSort",
		"name": "BubbleSort",
		"desc" : "Bubble Sort is a simple algorithm which is used to sort a given set of n elements provided in form of an array with n number of elements. Bubble Sort compares all the element one by one and sort them based on their values.\n‎Time-Complexity: O(n^2)‎‎‏‏‎‏‏‎‎‏‏‎\n ‎‎Space-Complexity: O(n)"
	},
	{
		"id": 4,
		"algoName": "Visualize SelectionSort",
		"name": "SelectionSort",
		"desc" : "The selection sort algorithm sorts an array by repeatedly finding the minimum element (considering ascending order) from unsorted part and putting it at the beginning. The algorithm maintains two subarrays in a given array. In every iteration of selection sort, the minimum element (considering ascending order) from the unsorted subarray is picked and moved to the sorted subarray.‏‏‎\n‎‏‏‎‎‏‏‎ ‎Time-Complexity: O(n^2)\n Space-Complexity: O(1)"
	},
];


